<template>
    <v-app-bar app class="pr-lg-8" height="78" color="'#ffffff'">
        <div class="flex-grow-1"></div>
        <v-toolbar-title class="mr-8">
            <span class="mr-5">Hallo, {{ currentUser }}</span>
        </v-toolbar-title>
        <v-btn icon right @click="logoutUser">
            <v-icon color="#010101" size="18">fas fa-power-off</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import Axios from 'axios';
export default {
    data() {
        return {
            currentUser: ''
        };
    },
    created() {
        this.getCurrentUser();
    },
    methods: {
        logoutUser() {
            Axios.get('api/member/logout').then(response => {
                if (response.data.success) {
                    this.$store.commit('setLoggedInState', false);
                    this.$router.push(this.$route.query.redirect || '/');
                }
            });
        },

        getCurrentUser() {
            Axios.get('api/member/GetLoggedInMember')
                .then(response => {
                    if (response.data === null) {
                        return false;
                    }
                    this.currentUser = response.data.userName;
                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss" scoped>
.theme--light.v-sheet {
    background-color: #f9f9f9;
}
</style>
